import ImageCard from "../../atoms/ImageCard";

const UserCard = ({ userTitle, userImage, description }) => {
  return (
    <div className="bg-[#E8EFF8]">
      <div className=" transition duration-150 ease-out  hover:ease-in hover:border border-blue-800 hover:border-t-0 mt-8">
        <ImageCard
          iconDisplay="flex"
          classnames="w-[10rem] h-[12rem] bg-cover bg-center m-auto"
          userImage={userImage}
        />
      </div>
      <div className="hover:border border-blue-800 hover:border-b-0">
        <div className="mt-5 mb-4 ">
          <h1 className="text-black-700 text-center text-3xl font-bold leading-[2.3925rem]">
            {userTitle}
          </h1>
        </div>
        <div className="mx-13 mb-5 px-6">
          <h2 className=" text-black-400 text-center text-base leading-[1.11625rem]">
            {description}
          </h2>
        </div>
      </div>
    </div>
  );
};
export default UserCard;
